<template>
  <div class="row">
    <h1>Project Search</h1>
    <div class="col-3">
      <ul>
        <li v-for='result in searchResults'
         :key='result.id'>
          {{result.id}}
        </li>
      </ul>
    </div>
    <div class="col-9">
      <b-button
         @click="exportResults">
        Export
      </b-button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import api from '@/api';

export default {
  name: 'ProjectSearch',
  mounted() {
    // dispatch actions to populate vuex state for this page
    this.$store.dispatch('CurrentProject/search');
  },
  computed: {
    ...mapState('CurrentProject', {
      searchResults: state => state.searchResults,
    }),
  },
  methods: {
    exportResults() {
      api.get(`/project/exportsearchresults?ids=${this.searchResults.map(r => r.id).join('&ids=')}`, {
        responseType: 'arraybuffer',
      }).then((response) => {
        const responseFileName = this.getFileNameFromResponseHeader(response);
        const blob = new Blob([response.data], { type: 'application/zip' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = responseFileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch((error) => {
        console.log(error);
      });
    },
    getFileNameFromResponseHeader(response) {
      const filenameRegex = /filename=(.*);/;
      const matches = filenameRegex.exec(response.headers['content-disposition']);
      const filename = matches ? matches[1] : 'ProjectSearchResults.zip';
      return filename;
    },
  },
};
</script>
